module.exports = __webpack_public_path__ + "img/picture_white.08606a5d.svg";